export default __webpack_public_path__ + "static/media/print.22244c9e.jpeg";